

(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();

    $(document).ready(function (e) {
        $(".partialContents").each(function (index, item) {

            var url = $(item).data("url");
            if (url && url.length > 0) {
                $(item).load(url);
            }
        });
    });


})(window, document, jQuery);